<template>
  <table class="table is-bordered is-fullwidth access-control-table"
    :key="tableKey">
    <tbody>
      <template v-for="parent in tree">
        <template v-for="row in renderRows(parent, 0)">
          <tr :key="row.permission.id"
            :class="{ 'access-parent-row ': row.level === 0, [`theme-${$theme.name}`]: row.level === 0 }">
            <td :style="row.level > 0 ? { paddingLeft: `${row.level * 24}px` } : {}">{{ row.permission.name }}</td>
            <td class="has-text-centered">
              <div class="pretty p-icon p-curve p-smooth p-bigger m-0">
                <input type="checkbox"
                  v-model="row.permission.isSelected"
                  @change="handleToggle(row.permission, row.level)"
                  :disabled="!row.permission.active">
                <div class="state p-primary">
                  <span class="icon mso mso-24px">check</span>
                  <label />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </template>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'PermissionTree',
  props: {
    tree: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredTree() {
      function filterNodes(nodes) {
        return nodes
          .map((node) => {
            if (node.children && node.children.length) {
              const filteredChildren = filterNodes(node.children)
              if (node.isSelected || filteredChildren.length > 0) {
                node.isSelected = node.isSelected && node.active
                return { ...node, children: filteredChildren }
              }
              return null
            }
            if (node.isSelected) {
              node.isSelected = node.isSelected && node.active
              return node
            } else return null
          })
          .filter(Boolean)
      }
      return filterNodes(this.tree)
    }
  },
  watch: {
    tree: {
      handler(newVal) {
        this.localTree = JSON.parse(JSON.stringify(newVal))
      },
      deep: true
    }
  },
  data() {
    return {
      tableKey: 0
    }
  },
  methods: {
    renderRows(permission, level) {
      const rows = [{ permission, level }]
      if (permission.children && permission.children.length) {
        permission.children.forEach((child) => {
          rows.push(...this.renderRows(child, level + 1))
        })
      }
      return rows
    },
    handleToggle(permission, level) {
      const vm = this
      function toggleChildren(node, isSelected) {
        if (node.children && node.children.length) {
          node.children.forEach((child) => {
            vm.$set(child, 'isSelected', child.active ? isSelected : false)
            if (!isSelected) {
              vm.$set(child, 'IsDeleted', true)
            } else {
              vm.$set(child, 'IsDeleted', false)
            }
            toggleChildren(child, isSelected)
          })
        }
      }
      if (!permission.isSelected) {
        this.$set(permission, 'IsDeleted', true)
      } else {
        this.$set(permission, 'IsDeleted', false)
      }
      if (permission.children && permission.children.length) {
        toggleChildren(permission, permission.isSelected)
      }
      this.tableKey++
      this.$emit('update', JSON.parse(JSON.stringify(this.tree)))
    }
  }
}
</script>

<style scoped>
.access-parent-row {
  background: hsl(222, 77%, 95%);
  font-weight: bold;
}

.access-parent-row.theme-dark {
  background: hsl(222, 77%, 15%);
}
</style>